import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  errorCodeSelector,
  userSelector,
} from './store/selector';
import { meApiService } from './services/api';
import {
  getMeUserFailureApiAction,
  getMeUserInitApiAction,
  getMeUserSuccessApiAction,
  meClearAction,
  putMePasswordFailureApiAction,
  putMePasswordInitApiAction,
  putMePasswordSuccessApiAction,
  putMeUserFailureApiAction,
  putMeUserInitApiAction,
  putMeUserSuccessApiAction,
} from './store/reducer';
import { PutMeUserPayloadRequest } from './interfaces/put-me-user';
import { PutMePasswordPayloadRequest } from './interfaces/put-me-password';
import { GetMeUserResponse } from './interfaces/get-me-user';

export function useMeCore() {
  const user = useSelector(userSelector);
  const errorCode = useSelector(errorCodeSelector);
  const dispatch = useDispatch();

  const getMeUser = useCallback(
    async (onSuccess?: (arg0: GetMeUserResponse) => void, onFailure?: () => void) => {
      try {
        dispatch(getMeUserInitApiAction());
        const response = await meApiService.getMeUser();
        dispatch(getMeUserSuccessApiAction(response));
        onSuccess?.(response);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getMeUserFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putMeUser = useCallback(
    async (body: PutMeUserPayloadRequest, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(putMeUserInitApiAction());
        await meApiService.putMeUser(body);
        dispatch(putMeUserSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putMeUserFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const putMePassword = useCallback(
    async (body: PutMePasswordPayloadRequest, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(putMePasswordInitApiAction());
        await meApiService.putMePassword(body);
        dispatch(putMePasswordSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putMePasswordFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const clearMe = useCallback(() => {
    dispatch(meClearAction());
  }, [dispatch]);

  return {
    user,
    errorCode,
    getMeUser,
    putMeUser,
    putMePassword,
    clearMe,
  };
}
